/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * dashboard API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseDashboardPermissionResponse,
  ApiResponseLong,
  GetV11DashboardsPermissionParams,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary checkDashboardPermission
 */
export const getV11DashboardsPermission = (
  params: MaybeRef<GetV11DashboardsPermissionParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseDashboardPermissionResponse>(
    { url: `/api/v11/dashboards/permission`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV11DashboardsPermissionQueryKey = (
  params?: MaybeRef<GetV11DashboardsPermissionParams>,
) => {
  return ['api', 'v11', 'dashboards', 'permission', ...(params ? [params] : [])] as const;
};

export const getGetV11DashboardsPermissionQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11DashboardsPermission>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11DashboardsPermissionParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11DashboardsPermission>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11DashboardsPermissionQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11DashboardsPermission>>> = ({
    signal,
  }) => getV11DashboardsPermission(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11DashboardsPermission>>,
    TError,
    TData
  >;
};

export type GetV11DashboardsPermissionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11DashboardsPermission>>
>;
export type GetV11DashboardsPermissionQueryError = ErrorType<unknown>;

/**
 * @summary checkDashboardPermission
 */

export function useGetV11DashboardsPermission<
  TData = Awaited<ReturnType<typeof getV11DashboardsPermission>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV11DashboardsPermissionParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11DashboardsPermission>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11DashboardsPermissionQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary startScreen
 */
export const getV11DashboardsStartScreen = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ApiResponseLong>(
    { url: `/api/v11/dashboards/start-screen`, method: 'GET', signal },
    options,
  );
};

export const getGetV11DashboardsStartScreenQueryKey = () => {
  return ['api', 'v11', 'dashboards', 'start-screen'] as const;
};

export const getGetV11DashboardsStartScreenQueryOptions = <
  TData = Awaited<ReturnType<typeof getV11DashboardsStartScreen>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV11DashboardsStartScreen>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV11DashboardsStartScreenQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV11DashboardsStartScreen>>> = ({
    signal,
  }) => getV11DashboardsStartScreen(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV11DashboardsStartScreen>>,
    TError,
    TData
  >;
};

export type GetV11DashboardsStartScreenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV11DashboardsStartScreen>>
>;
export type GetV11DashboardsStartScreenQueryError = ErrorType<unknown>;

/**
 * @summary startScreen
 */

export function useGetV11DashboardsStartScreen<
  TData = Awaited<ReturnType<typeof getV11DashboardsStartScreen>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV11DashboardsStartScreen>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV11DashboardsStartScreenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
